import { render, staticRenderFns } from "./TDraftEdit.vue?vue&type=template&id=269f333a&"
import script from "./TDraftEdit.vue?vue&type=script&lang=js&"
export * from "./TDraftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269f333a')) {
      api.createRecord('269f333a', component.options)
    } else {
      api.reload('269f333a', component.options)
    }
    module.hot.accept("./TDraftEdit.vue?vue&type=template&id=269f333a&", function () {
      api.rerender('269f333a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/directPayments/TDraftEdit.vue"
export default component.exports